module.exports = __webpack_public_path__ + "img/75747.8d6fec50.svg";